import axiosInstance from "./AxiosInstance";
export function getinitialdata(params = {}) {
  const queryParams = new URLSearchParams(params).toString();
  return axiosInstance.get(
    `api/transport/bus-route-initial-location?${queryParams}`
  );
}
